import {Injectable} from "@angular/core";
import {Location} from "@angular/common";
import {IDocument} from "../interfaces/document.definition";


@Injectable()
export class QueryService {
  constructor(private location: Location) {
  }


  update(document:IDocument) {
    let params = new URLSearchParams();
    params.set("_id", document._id);

    let path = this.reset();
    this.location.replaceState(path, `?${params.toString()}`);
  }


  reset() {
    let path = this.location.path().replace(/\?.+/, "");
    this.location.replaceState(path);
    return path;
  }


  get documentId():string {
    let re = /_id=([a-f0-9]{24})/i;
    let result = re.exec(this.location.path());
    if (result) {
      return result[1];
    }
    return null;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/query.service.ts